import type { ComponentProps } from 'react';
import { cn } from '../lib/utils.js';
import { badgeVariants, type BadgeVariantProps } from './badge-variants.js';

export function Badge({
  className,
  variant,
  ...props
}: ComponentProps<'span'> & BadgeVariantProps) {
  return (
    <span data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export function Kbd({ className, ...props }: ComponentProps<'kbd'>) {
  return (
    <kbd
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded border border-border bg-muted px-1 font-mono text-[10px] text-muted-foreground',
        className,
      )}
      {...props}
    />
  );
}
